import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CITYTAX_PACKAGE, SILENT_SUBSTITUTION_STORAGE_KEY, DATE_TYPE, EARLY_CHECKIN_IDS, LATE_CHECKOUT_IDS, VALID_EXTRAS_IDS } from '@whitbread-eos/api';
import { isAfter, isBefore, isValid, isWithinInterval, parse } from 'date-fns';
import { formatAssetsUrl, filterAncillaryCloseOutData } from '../formatters';
import { isStringValid } from '../validators';
export var validateMealAssetsSrc = meal => {
  var allergyInfoSrc = meal.allergyInfoSrc;
  if (typeof allergyInfoSrc !== 'undefined' && isStringValid(allergyInfoSrc)) {
    return allergyInfoSrc.startsWith('http') ? allergyInfoSrc : formatAssetsUrl(allergyInfoSrc);
  }
  return '';
};
export var enhanceMeal = meal => {
  var _meal$imageSrc;
  return _objectSpread(_objectSpread({}, meal), {}, {
    allergyInfoSrc: validateMealAssetsSrc(meal),
    imageSrc: isStringValid(meal.imageSrc) ? formatAssetsUrl((_meal$imageSrc = meal.imageSrc) !== null && _meal$imageSrc !== void 0 ? _meal$imageSrc : '') : ''
  });
};
export var enhancePrivacyPolicyMoreInfoItem = moreInfo => moreInfo ? moreInfo.map(moreInfoItem => {
  var _moreInfoItem$image;
  return _objectSpread(_objectSpread({}, moreInfoItem), {}, {
    image: formatAssetsUrl((_moreInfoItem$image = moreInfoItem.image) !== null && _moreInfoItem$image !== void 0 ? _moreInfoItem$image : '')
  });
}) : [];
export var sortMealsByOrderOrName = (firstMeal, secondMeal) => {
  if (firstMeal.order === secondMeal.order || firstMeal.order === null || secondMeal.order === null) {
    return firstMeal.name && secondMeal.name ? firstMeal.name.toUpperCase() > secondMeal.name.toUpperCase() ? 1 : -1 : null;
  } else return firstMeal.order && secondMeal.order ? firstMeal.order - secondMeal.order : null;
};
export var adultsMealsSelector = function adultsMealsSelector(adultsMeals, noNights) {
  var noTotalAdults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!adultsMeals) return [];
  var mappedMeals = adultsMeals.map(meal => _objectSpread(_objectSpread(_objectSpread({}, meal), enhanceMeal(meal)), {}, {
    totalPrice: meal !== null && meal !== void 0 && meal.price ? (meal === null || meal === void 0 ? void 0 : meal.price) * noNights : 0,
    totalPriceForEntireStay: meal !== null && meal !== void 0 && meal.price ? (meal === null || meal === void 0 ? void 0 : meal.price) * noNights * noTotalAdults : 0
  })).sort(sortMealsByOrderOrName);
  var hasFreeMeal = mappedMeals === null || mappedMeals === void 0 ? void 0 : mappedMeals.some(meal => meal === null || meal === void 0 ? void 0 : meal.isFree);
  if (!hasFreeMeal) return mappedMeals;
  return [...mappedMeals.filter(meal => meal === null || meal === void 0 ? void 0 : meal.isFree), ...mappedMeals.filter(meal => !(meal !== null && meal !== void 0 && meal.isFree))];
};
export var freeBreakfastMaxAllowance = adultsMeals => adultsMeals.reduce((acc, current) => current !== null && current !== void 0 && current.freeBreakfastOption && current !== null && current !== void 0 && current.freeBreakfastMaxPerMeal ? acc + (current === null || current === void 0 ? void 0 : current.freeBreakfastMaxPerMeal) : acc, 0);
export var freeBreakfastMaxSelectedAllowance = (adultsMealsSelection, adultsMeals) => {
  var enhancedSelectedMeals = adultsMealsSelection ? adultsMealsSelection.map(meal => adultsMeals.filter(item => item.id === meal)[0]) : [];
  return freeBreakfastMaxAllowance(enhancedSelectedMeals);
};
export var childrenMealsSelector = childrenMeals => childrenMeals ? childrenMeals.map(meal => _objectSpread(_objectSpread({}, meal), enhanceMeal(meal))).sort(sortMealsByOrderOrName) : [];
export var menusSelector = (adultMeals, mealsKids) => {
  var formattedMenus = [...adultMeals.filter(meal => meal.menu !== null), ...mealsKids.filter(meal => meal.menu !== null)];
  return formattedMenus.filter((meal, index, arrOfMeals) => arrOfMeals.findIndex(item => {
    var _item$menu, _meal$menu;
    return (item === null || item === void 0 || (_item$menu = item.menu) === null || _item$menu === void 0 ? void 0 : _item$menu.menuSrc) === (meal === null || meal === void 0 || (_meal$menu = meal.menu) === null || _meal$menu === void 0 ? void 0 : _meal$menu.menuSrc);
  }) === index).map(item => {
    var _item$menu2, _item$menu$menuSrc, _item$menu3;
    return {
      name: item === null || item === void 0 || (_item$menu2 = item.menu) === null || _item$menu2 === void 0 ? void 0 : _item$menu2.name,
      menuSrc: formatAssetsUrl((_item$menu$menuSrc = item === null || item === void 0 || (_item$menu3 = item.menu) === null || _item$menu3 === void 0 ? void 0 : _item$menu3.menuSrc) !== null && _item$menu$menuSrc !== void 0 ? _item$menu$menuSrc : '')
    };
  });
};
export var securityNoticeMoreInfoDataSelector = privacyPolicy => {
  var _privacyPolicy$moreIn, _privacyPolicy$linkSr;
  return _objectSpread(_objectSpread({}, privacyPolicy), {}, {
    moreInfo: enhancePrivacyPolicyMoreInfoItem((_privacyPolicy$moreIn = privacyPolicy.moreInfo) !== null && _privacyPolicy$moreIn !== void 0 ? _privacyPolicy$moreIn : []),
    linkSrc: isStringValid(privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.linkSrc) ? formatAssetsUrl((_privacyPolicy$linkSr = privacyPolicy.linkSrc) !== null && _privacyPolicy$linkSr !== void 0 ? _privacyPolicy$linkSr : '') : ''
  });
};
export var enhanceSelectedMeals = (roomMealsSelections, adultsMeals, childrenMeals) => ({
  adultsMeals: adultsMeals ? adultsMeals.filter(meal => {
    var _meal$id;
    return roomMealsSelections === null || roomMealsSelections === void 0 ? void 0 : roomMealsSelections.adults.includes((_meal$id = meal.id) !== null && _meal$id !== void 0 ? _meal$id : '');
  }).map(meal => {
    var _meal$price;
    return {
      title: meal.name,
      id: meal.id,
      price: (_meal$price = meal === null || meal === void 0 ? void 0 : meal.price) !== null && _meal$price !== void 0 ? _meal$price : 0,
      noSelections: roomMealsSelections.adults.filter(sel => sel === meal.id).length
    };
  }) : [],
  childrenMeals: childrenMeals ? childrenMeals.filter(meal => {
    var _meal$id2;
    return roomMealsSelections === null || roomMealsSelections === void 0 ? void 0 : roomMealsSelections.children.includes((_meal$id2 = meal.id) !== null && _meal$id2 !== void 0 ? _meal$id2 : '');
  }).map(meal => ({
    title: meal.name,
    id: meal.id,
    noSelections: roomMealsSelections.children.filter(sel => sel === meal.id).length
  })) : []
});
export var selectedMealsPerRoomSelector = (selectedMeals, adultsMeals, childrenMeals) => selectedMeals && selectedMeals.length > 0 ? selectedMeals.map(roomMealsSelection => enhanceSelectedMeals(roomMealsSelection, adultsMeals, childrenMeals)) : [];
export var roomInformationSelector = (reservationListItems, selectedMeals, adultsMeals, childrenMeals, selectedExtrasList) => reservationListItems && reservationListItems.length > 0 ? reservationListItems.map((_ref, index) => {
  var _roomStay$adultsNumbe, _roomStay$childrenNum, _roomStay$roomExtraIn, _roomStay$roomExtraIn2, _roomStay$accessibleR, _roomStay$accessibleR2, _roomStay$accessibleR3;
  var roomStay = _ref.roomStay,
    reservationId = _ref.reservationId;
  var selectedExtrasFound = selectedExtrasList === null || selectedExtrasList === void 0 ? void 0 : selectedExtrasList.find(extrasItem => extrasItem.reservationId === reservationId);
  return _objectSpread({
    nrAdults: (_roomStay$adultsNumbe = roomStay === null || roomStay === void 0 ? void 0 : roomStay.adultsNumber) !== null && _roomStay$adultsNumbe !== void 0 ? _roomStay$adultsNumbe : 0,
    nrChildren: (_roomStay$childrenNum = roomStay === null || roomStay === void 0 ? void 0 : roomStay.childrenNumber) !== null && _roomStay$childrenNum !== void 0 ? _roomStay$childrenNum : 0,
    roomType: roomStay === null || roomStay === void 0 || (_roomStay$roomExtraIn = roomStay.roomExtraInfo) === null || _roomStay$roomExtraIn === void 0 ? void 0 : _roomStay$roomExtraIn.roomType,
    roomName: roomStay === null || roomStay === void 0 || (_roomStay$roomExtraIn2 = roomStay.roomExtraInfo) === null || _roomStay$roomExtraIn2 === void 0 ? void 0 : _roomStay$roomExtraIn2.roomName,
    selectedMeals: enhanceSelectedMeals(selectedMeals[index], adultsMeals, childrenMeals),
    selectedExtrasList: selectedExtrasFound,
    accessibleRoom: {
      isAccessible: !!(roomStay !== null && roomStay !== void 0 && (_roomStay$accessibleR = roomStay.accessibleRoom) !== null && _roomStay$accessibleR !== void 0 && _roomStay$accessibleR.isAccessible),
      phoneNumber: (_roomStay$accessibleR2 = roomStay === null || roomStay === void 0 || (_roomStay$accessibleR3 = roomStay.accessibleRoom) === null || _roomStay$accessibleR3 === void 0 ? void 0 : _roomStay$accessibleR3.phoneNumber) !== null && _roomStay$accessibleR2 !== void 0 ? _roomStay$accessibleR2 : ''
    }
  }, reservationId ? {
    reservationId
  } : {});
}) : [];
export var numberOfSelectionsPerRoomSelector = selectedMeals => {
  return selectedMeals.map(room => {
    var adultsMeals = room.adults.reduce((acc, value) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [value]: (acc[value] || 0) + 1
      });
    }, {});
    var childrenMeals = room.children.reduce((acc, value) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [value]: (acc[value] || 0) + 1
      });
    }, {});
    var reservationId = room.reservationId;
    var adultsMealList = Object.keys(adultsMeals).map(key => ({
      id: key,
      noOfSelections: adultsMeals[key]
    }));
    var childrenMealsList = Object.keys(childrenMeals).map(key => ({
      id: key,
      noOfSelections: childrenMeals[key]
    }));
    return {
      reservationId: reservationId,
      packagesSelection: [...adultsMealList, ...childrenMealsList]
    };
  });
};
export var mealsMapperSelector = (adultsMeals, childrenMeals, roomSelections, isAdultHasMealsFree, listGuests) => {
  var finalList = [];
  var adultsIds = adultsMeals === null || adultsMeals === void 0 ? void 0 : adultsMeals.map(meal => meal.id);
  var childrenIds = childrenMeals === null || childrenMeals === void 0 ? void 0 : childrenMeals.map(meal => meal.id);
  roomSelections === null || roomSelections === void 0 || roomSelections.forEach((room, roomIndex) => {
    var _listGuests$childrenN, _listGuests$childrenN2;
    var mealDistribution = {
      adults: [],
      children: [],
      reservationId: room === null || room === void 0 ? void 0 : room.reservationId
    };
    var hasChildren = ((_listGuests$childrenN = listGuests === null || listGuests === void 0 || (_listGuests$childrenN2 = listGuests.childrenNumber) === null || _listGuests$childrenN2 === void 0 ? void 0 : _listGuests$childrenN2[roomIndex]) !== null && _listGuests$childrenN !== void 0 ? _listGuests$childrenN : 0) > 0;
    if (isAdultHasMealsFree && listGuests) {
      var _room$packagesSelecti;
      room === null || room === void 0 || (_room$packagesSelecti = room.packagesSelection) === null || _room$packagesSelecti === void 0 || _room$packagesSelecti.forEach(pcks => {
        var _pcks$noOfSelections;
        var count = (_pcks$noOfSelections = pcks.noOfSelections) !== null && _pcks$noOfSelections !== void 0 ? _pcks$noOfSelections : 0;
        if (adultsIds !== null && adultsIds !== void 0 && adultsIds.includes(pcks.id)) {
          mealDistribution.adults = Array(count).fill(pcks.id).concat(mealDistribution.adults);
          var meal = adultsMeals === null || adultsMeals === void 0 ? void 0 : adultsMeals.find(m => m.id === pcks.id);
          if (hasChildren && meal !== null && meal !== void 0 && meal.freeBreakfastOption && meal.freeBreakfastCode) {
            var isValidChild = childrenIds === null || childrenIds === void 0 ? void 0 : childrenIds.includes(meal.freeBreakfastCode);
            if (isValidChild) {
              var _listGuests$childrenN3, _listGuests$childrenN4;
              var childCount = (_listGuests$childrenN3 = (_listGuests$childrenN4 = listGuests.childrenNumber) === null || _listGuests$childrenN4 === void 0 ? void 0 : _listGuests$childrenN4[roomIndex]) !== null && _listGuests$childrenN3 !== void 0 ? _listGuests$childrenN3 : 0;
              mealDistribution.children = Array(childCount).fill(meal.freeBreakfastCode).concat(mealDistribution.children);
            }
          }
        } else if (childrenIds !== null && childrenIds !== void 0 && childrenIds.includes(pcks.id)) {
          if (hasChildren) {
            mealDistribution.children = Array(count).fill(pcks.id).concat(mealDistribution.children);
          }
        }
      });
    } else if (room.packagesSelection && room.packagesSelection.length > 0) {
      room === null || room === void 0 || room.packagesSelection.forEach(pcks => {
        var _pcks$noOfSelections2;
        var count = (_pcks$noOfSelections2 = pcks.noOfSelections) !== null && _pcks$noOfSelections2 !== void 0 ? _pcks$noOfSelections2 : 0;
        if (adultsIds !== null && adultsIds !== void 0 && adultsIds.includes(pcks.id)) {
          mealDistribution.adults = Array(count).fill(pcks.id).concat(mealDistribution.adults);
        } else if (childrenIds !== null && childrenIds !== void 0 && childrenIds.includes(pcks.id)) {
          mealDistribution.children = Array(count).fill(pcks.id).concat(mealDistribution.children);
        }
      });
    }
    finalList.push(mealDistribution);
  });
  return finalList;
};
export var autocompleteMeals = (adultsMeals, childrenMeals, listGuests, prefUserMealId) => {
  var finalList = [];
  var prefMeal = adultsMeals.find(meal => meal.id === prefUserMealId);
  var associateChildMeal = childrenMeals.find(meal => meal.id === (prefMeal === null || prefMeal === void 0 ? void 0 : prefMeal.freeBreakfastCode));
  listGuests.adultsNumber.forEach((adults, index) => {
    finalList.push({
      adults: !prefMeal ? [] : Array(adults).fill(prefMeal === null || prefMeal === void 0 ? void 0 : prefMeal.id),
      children: prefMeal !== null && prefMeal !== void 0 && prefMeal.freeBreakfastOption && associateChildMeal ? Array(listGuests.childrenNumber[index]).fill(associateChildMeal.id) : []
    });
  });
  return finalList;
};
export var calculateTotalCostRoomSelection = (adultsMeals, roomSelections, noOfNights) => {
  var totalCost = 0;
  roomSelections === null || roomSelections === void 0 || roomSelections.forEach(room => {
    var _room$packagesSelecti2;
    if (room.packagesSelection && ((_room$packagesSelecti2 = room.packagesSelection) === null || _room$packagesSelecti2 === void 0 ? void 0 : _room$packagesSelecti2.length) > 0) {
      room.packagesSelection.forEach(pcks => {
        var meal = adultsMeals === null || adultsMeals === void 0 ? void 0 : adultsMeals.find(meal => meal.id === pcks.id);
        var mealPrice = meal ? meal.price : 0;
        if (mealPrice && pcks !== null && pcks !== void 0 && pcks.noOfSelections) {
          totalCost += mealPrice * (pcks === null || pcks === void 0 ? void 0 : pcks.noOfSelections) * noOfNights;
        }
      });
    }
  });
  return Number(totalCost.toFixed(2));
};
export var formatImportantNotes = (importantMessages, arrivalDate, departureDate) => {
  var sortedNotesByPriority = importantMessages === null || importantMessages === void 0 ? void 0 : importantMessages.sort((a, b) => a !== null && a !== void 0 && a.priority && b !== null && b !== void 0 && b.priority && (a === null || a === void 0 ? void 0 : a.priority) > (b === null || b === void 0 ? void 0 : b.priority) ? 1 : -1);
  return sortedNotesByPriority.filter(note => {
    var _note$startDate, _note$endDate;
    var newStartDate = parse((_note$startDate = note === null || note === void 0 ? void 0 : note.startDate) !== null && _note$startDate !== void 0 ? _note$startDate : '', DATE_TYPE.DD_MM_YYYY, new Date());
    var newEndDate = parse((_note$endDate = note === null || note === void 0 ? void 0 : note.endDate) !== null && _note$endDate !== void 0 ? _note$endDate : '', DATE_TYPE.DD_MM_YYYY, new Date());
    var arrival = parse(arrivalDate, DATE_TYPE.YEAR_MONTH_DAY, new Date());
    var departure = parse(departureDate, DATE_TYPE.YEAR_MONTH_DAY, new Date());
    return newStartDate <= arrival && arrival <= newEndDate || newStartDate <= departure && departure <= newEndDate || arrival <= newStartDate && departure >= newEndDate;
  }).map(item => {
    var _item$htmlText;
    return (_item$htmlText = item.htmlText) !== null && _item$htmlText !== void 0 && _item$htmlText.trim() ? item.htmlText : item.text;
  }).join('<br/>');
};
export var getImportantMessages = (importantMessages, arrivalDate, departureDate) => {
  var validImportantMessages = (importantMessages !== null && importantMessages !== void 0 ? importantMessages : []).filter(item => !!item && !item.hideOnBookingFlow);
  if (!arrivalDate || !departureDate) return [];
  var messages = formatImportantNotes(validImportantMessages, arrivalDate, departureDate);
  return messages.length > 0 ? [messages] : [];
};
export var getUniqueRoomProperties = function getUniqueRoomProperties(rooms) {
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'roomType';
  return rooms === null || rooms === void 0 ? void 0 : rooms.map(room => {
    var _room$roomStay;
    return room === null || room === void 0 || (_room$roomStay = room.roomStay) === null || _room$roomStay === void 0 || (_room$roomStay = _room$roomStay.roomExtraInfo) === null || _room$roomStay === void 0 ? void 0 : _room$roomStay[property];
  }).filter((value, index, self) => self.indexOf(value) === index).join();
};
export var checkIfExistPreselection = roomSelections => {
  return roomSelections === null || roomSelections === void 0 ? void 0 : roomSelections.some(room => {
    var _room$packagesSelecti3;
    return (room === null || room === void 0 ? void 0 : room.packagesSelection) && (room === null || room === void 0 || (_room$packagesSelecti3 = room.packagesSelection) === null || _room$packagesSelecti3 === void 0 ? void 0 : _room$packagesSelecti3.length) > 0;
  });
};
export var shouldDisplayAutocompleteNotification = (listGuests, selectedMeals, prefMealId) => {
  return selectedMeals.every((roomSelected, indexSel) => {
    var prefAdultMealForEntire = roomSelected.adults.filter(meal => meal === prefMealId.adultMeal).length === listGuests.adultsNumber[indexSel];
    var prefChildrenMealsForEntire = listGuests.childrenNumber[indexSel] > 0 && isStringValid(prefMealId.childMeal) ? roomSelected.children.filter(meal => meal === prefMealId.childMeal).length === listGuests.childrenNumber[indexSel] : true;
    return prefAdultMealForEntire && prefChildrenMealsForEntire;
  });
};
export var transformBartIdToOperaId = (bartId, meals) => {
  var _meals$find$id, _meals$find;
  return (_meals$find$id = (_meals$find = meals.find(meal => meal.bartId === bartId)) === null || _meals$find === void 0 ? void 0 : _meals$find.id) !== null && _meals$find$id !== void 0 ? _meals$find$id : '';
};
export var isCityTaxAvailable = function isCityTaxAvailable() {
  var roomSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLeisure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return isLeisure && roomSelection && roomSelection.length > 0 ? roomSelection.some(room => room.packagesSelection ? room.packagesSelection.some(pck => (pck === null || pck === void 0 ? void 0 : pck.id) === CITYTAX_PACKAGE && (pck === null || pck === void 0 ? void 0 : pck.noOfSelections) > 0) : false) : false;
};
export function sortMealsByReservationId(mealsInfo, reservations) {
  var orderedMeals = [];
  reservations.forEach(reservation => {
    var mealPackage = mealsInfo.find(meal => meal.reservationId === reservation.reservationId);
    mealPackage && orderedMeals.push(mealPackage);
  });
  return orderedMeals;
}
export function isAncillaryCloseoutItemActiveForStay(ancillaryCloseoutItem, bookingArrivalDate, bookingDepartureDate) {
  var _ancillaryCloseoutIte, _ancillaryCloseoutIte2;
  var arrivalDate = parse(bookingArrivalDate, DATE_TYPE.YEAR_MONTH_DAY, new Date());
  var departureDate = parse(bookingDepartureDate, DATE_TYPE.YEAR_MONTH_DAY, new Date());
  var closeoutStartDate = parse((_ancillaryCloseoutIte = ancillaryCloseoutItem.startDate) !== null && _ancillaryCloseoutIte !== void 0 ? _ancillaryCloseoutIte : '', DATE_TYPE.DD_MM_YYYY, new Date());
  var closeoutEndDate = parse((_ancillaryCloseoutIte2 = ancillaryCloseoutItem.endDate) !== null && _ancillaryCloseoutIte2 !== void 0 ? _ancillaryCloseoutIte2 : '', DATE_TYPE.DD_MM_YYYY, new Date());
  if (!isValid(arrivalDate) || !isValid(departureDate) || !isValid(closeoutStartDate) || !isValid(closeoutEndDate) || !isBefore(closeoutStartDate, closeoutEndDate)) {
    return false;
  }
  var ischeckinDateBeweenCloseout = isWithinInterval(arrivalDate, {
    start: closeoutStartDate,
    end: closeoutEndDate
  });
  var ischeckoutDateBeweenCloseout = isWithinInterval(departureDate, {
    start: closeoutStartDate,
    end: closeoutEndDate
  });
  var isCloseoutBeweenBookingInterval = isAfter(closeoutStartDate, arrivalDate) && isBefore(closeoutEndDate, departureDate);
  return ischeckinDateBeweenCloseout || ischeckoutDateBeweenCloseout || isCloseoutBeweenBookingInterval;
}
export function filterPackagesByAncillariesCloseOut(ancillaryFilterData) {
  var ancillaryData = filterAncillaryCloseOutData(ancillaryFilterData.ancillaryCloseoutData);
  var packageCodeSet = new Set();
  ancillaryData === null || ancillaryData === void 0 || ancillaryData.map(ancillaryCloseoutItem => {
    if (isAncillaryCloseoutItemActiveForStay(ancillaryCloseoutItem, ancillaryFilterData.arrivalDate, ancillaryFilterData.departureDate)) {
      var _ancillaryCloseoutIte3;
      var packageCodes = ancillaryCloseoutItem === null || ancillaryCloseoutItem === void 0 || (_ancillaryCloseoutIte3 = ancillaryCloseoutItem.upsellCodes) === null || _ancillaryCloseoutIte3 === void 0 ? void 0 : _ancillaryCloseoutIte3.split(',');
      packageCodes === null || packageCodes === void 0 || packageCodes.forEach(item => {
        packageCodeSet.add(item.trim());
      });
    }
  });
  var filteredAdultsMeals = ancillaryFilterData.adultsMeals.filter(meal => !packageCodeSet.has(meal.id));
  var filteredChildrenMeals = ancillaryFilterData.childrenMeals.filter(meal => !packageCodeSet.has(meal.id));
  var filteredClosedOutMeals = ancillaryFilterData.adultsMeals.filter(meal => packageCodeSet.has(meal.id));
  return {
    filteredAdultsMeals,
    filteredChildrenMeals,
    filteredClosedOutMeals
  };
}
export function getCurrentReservationStorageData(reservationId) {
  if (typeof window !== 'undefined') {
    var roomStorageData = window.localStorage.getItem(SILENT_SUBSTITUTION_STORAGE_KEY);
    var parsedRoomStorageData = roomStorageData && JSON.parse(roomStorageData);
    return parsedRoomStorageData ? parsedRoomStorageData[reservationId] : null;
  }
  return null;
}
export var addReservationNumber = (roomSelections, reservationByIdList, selectedExtrasList) => {
  var roomPackagesSelection = [];
  if (reservationByIdList.length) {
    roomSelections.forEach((selection, index) => {
      var _reservationByIdList$2, _reservationByIdList$3;
      selectedExtrasList === null || selectedExtrasList === void 0 || selectedExtrasList.map(extras => {
        var _reservationByIdList$;
        if ((extras === null || extras === void 0 ? void 0 : extras.reservationId) === ((_reservationByIdList$ = reservationByIdList[index]) === null || _reservationByIdList$ === void 0 ? void 0 : _reservationByIdList$.reservationId)) {
          var _extras$packagesList;
          extras === null || extras === void 0 || (_extras$packagesList = extras.packagesList) === null || _extras$packagesList === void 0 || _extras$packagesList.forEach(extrasPackage => {
            var _selection$packagesSe;
            selection === null || selection === void 0 || (_selection$packagesSe = selection.packagesSelection) === null || _selection$packagesSe === void 0 || _selection$packagesSe.push({
              id: extrasPackage,
              noOfSelections: 1
            });
          });
        }
      });
      var selectionPerRoom = _objectSpread(_objectSpread({}, selection), {}, {
        reservationId: (_reservationByIdList$2 = (_reservationByIdList$3 = reservationByIdList[index]) === null || _reservationByIdList$3 === void 0 ? void 0 : _reservationByIdList$3.reservationId) !== null && _reservationByIdList$2 !== void 0 ? _reservationByIdList$2 : ''
      });
      return roomPackagesSelection.push(selectionPerRoom);
    });
  }
  return roomPackagesSelection;
};
export var extrasPackagesMapperSelector = roomSelections => {
  var extrasPackagesListPerRooms = roomSelections === null || roomSelections === void 0 ? void 0 : roomSelections.map(room => {
    var _room$packagesSelecti4;
    var extrasPackagesPerRoom = {
      packagesList: [],
      reservationId: room === null || room === void 0 ? void 0 : room.reservationId,
      price: 0,
      previousEciSelection: 0,
      previousLcoSelection: 0
    };
    room === null || room === void 0 || (_room$packagesSelecti4 = room.packagesSelection) === null || _room$packagesSelecti4 === void 0 || _room$packagesSelecti4.forEach(selectedPackage => {
      var id = selectedPackage === null || selectedPackage === void 0 ? void 0 : selectedPackage.id;
      if (!id) return;
      if (VALID_EXTRAS_IDS.includes(id)) {
        var _extrasPackagesPerRoo;
        if (!(extrasPackagesPerRoom !== null && extrasPackagesPerRoom !== void 0 && (_extrasPackagesPerRoo = extrasPackagesPerRoom.packagesList) !== null && _extrasPackagesPerRoo !== void 0 && _extrasPackagesPerRoo.includes(id))) {
          extrasPackagesPerRoom.packagesList.push(id);
        }
        if (EARLY_CHECKIN_IDS.includes(id)) {
          extrasPackagesPerRoom.previousEciSelection = 1;
        }
        if (LATE_CHECKOUT_IDS.includes(id)) {
          extrasPackagesPerRoom.previousLcoSelection = 1;
        }
      }
    });
    return extrasPackagesPerRoom;
  });
  return extrasPackagesListPerRooms;
};
export function addOrRemoveExtrasRoom(extrasId, price, selectedExtrasList, selectedRoom) {
  var _selectedExtrasList$s, _selectedExtrasList$s2;
  var canBeRemoved = selectedExtrasList === null || selectedExtrasList === void 0 || (_selectedExtrasList$s = selectedExtrasList[selectedRoom]) === null || _selectedExtrasList$s === void 0 ? void 0 : _selectedExtrasList$s.packagesList.includes(extrasId);
  var reservationIdPerRoom = selectedExtrasList === null || selectedExtrasList === void 0 || (_selectedExtrasList$s2 = selectedExtrasList[selectedRoom]) === null || _selectedExtrasList$s2 === void 0 || (_selectedExtrasList$s2 = _selectedExtrasList$s2.reservationId) === null || _selectedExtrasList$s2 === void 0 ? void 0 : _selectedExtrasList$s2.toString();
  var updatedExtrasItemsList = selectedExtrasList === null || selectedExtrasList === void 0 ? void 0 : selectedExtrasList.map(extrasItem => {
    if (extrasItem.reservationId === reservationIdPerRoom && !canBeRemoved) {
      extrasItem.packagesList.push(extrasId);
      extrasItem.price = extrasItem.price + price;
    }
    if (extrasItem.reservationId === reservationIdPerRoom && canBeRemoved) {
      var indexOfExtrasPackage = extrasItem.packagesList.indexOf(extrasId);
      extrasItem.packagesList.splice(indexOfExtrasPackage, 1);
      extrasItem.price = extrasItem.price - price;
    }
    return extrasItem;
  });
  return updatedExtrasItemsList;
}
export function addOrRemoveAllRoomsExtras(extrasId, price, selectedExtrasList, isRemovable) {
  var updatedExtrasItemsList = [];
  selectedExtrasList === null || selectedExtrasList === void 0 || selectedExtrasList.forEach(extrasItem => {
    var canBeRemoved = extrasItem === null || extrasItem === void 0 ? void 0 : extrasItem.packagesList.includes(extrasId);
    if (!isRemovable && !canBeRemoved) {
      extrasItem.packagesList.push(extrasId);
      extrasItem.price = extrasItem.price + price;
    }
    if (isRemovable && canBeRemoved) {
      var indexOfExtrasPackage = extrasItem.packagesList.indexOf(extrasId);
      extrasItem.packagesList.splice(indexOfExtrasPackage, 1);
      extrasItem.price = extrasItem.price - price;
    }
    updatedExtrasItemsList.push(extrasItem);
  });
  return updatedExtrasItemsList;
}
export function roomPackageSelection(selectedExtrasList) {
  var packageSelection = [];
  selectedExtrasList === null || selectedExtrasList === void 0 || selectedExtrasList.map(room => {
    var _room$packagesList;
    var roomExtras = room === null || room === void 0 || (_room$packagesList = room.packagesList) === null || _room$packagesList === void 0 ? void 0 : _room$packagesList.map(extras => {
      return {
        id: extras,
        noOfSelections: 1
      };
    });
    return packageSelection.push({
      packagesSelection: roomExtras,
      price: room === null || room === void 0 ? void 0 : room.price,
      reservationId: room === null || room === void 0 ? void 0 : room.reservationId
    });
  });
  return packageSelection;
}